import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const sendmail = () => {
    const link = "mailto:info@myprega.com?subject=About subscription";
    window.location.href = link;
  };

  return (
    <>
      <footer className="my-footer footer-padded">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-12">
              <Link to="/home" className="d-flex align-items-center text-decoration-none footer-brand-link">
                <img src="/logo.png" alt="Logo" style={{ height: "40px" }} />
                <span className="footer-logo-text">MyPrega</span>
              </Link>
              <p className="footer-description">
                Experience the future of pregnancy care with our all-inclusive, 
                tech-driven sanctuary designed for your absolute peace of mind.
              </p>
              <div className="social-container">
                <Link to="https://facebook.com/myprega" className="social-circle"><i className="bi bi-facebook"></i></Link>
                <Link to="https://instagram.com/myprega" className="social-circle"><i className="bi bi-instagram"></i></Link>
                <Link to="https://twitter.com/myprega" className="social-circle"><i className="bi bi-twitter"></i></Link>
              </div>
            </div>

            {/* Links Columns */}
            <div className="col-lg-7 col-md-12">
              <div className="row">
                <div className="col-6 col-md-4">
                  <h6 className="footer-column-title">Company</h6>
                  <ul className="footer-links">
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="/blogs">Careers</Link></li>
                    <li><Link to="/disclaimer-policy">Privacy Policy</Link></li>
                  </ul>
                </div>
                <div className="col-6 col-md-4">
                  <h6 className="footer-column-title">Resources</h6>
                  <ul className="footer-links">
                    <li><Link to="/elemental-care">How It Work</Link></li>
                    <li><Link to="/cherish-care">Benefits</Link></li>
                    <li><Link to="/success-stories">Testimonials</Link></li>
                  </ul>
                </div>
                <div className="col-6 col-md-4">
                  <h6 className="footer-column-title">Support</h6>
                  <ul className="footer-links">
                    <li><Link to="/faq">FAQs</Link></li>
                    <li><Link to="/contact">Help Center</Link></li>
                    <li><Link to="/terms-of-use">Terms & Conditions</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom-bar">
            <div className="row align-items-center">
              <div className="col-md-6 text-center text-md-start">
                <p className="copyright-text">
                  {new Date().getFullYear()} MyPrega All rights reserved
                </p>
              </div>
              <div className="col-md-6 text-center text-md-end mt-2 mt-md-0">
                <p className="copyright-text">
                  Developed with <span className="orange-heart">🧡</span> to support every mom-to-be
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <section className="marquee-section">
        <div className="marquee-content">MyPrega MyPrega MyPrega MyPrega</div>
        <div className="marquee-content" aria-hidden="true">MyPrega MyPrega MyPrega MyPrega</div>
      </section>
    </>
  );
};

export default Footer;
